import { createComponent, ElementWithProps } from '@carvana/merch-components';
import cx from 'classnames';

export const CardContainer = createComponent('a', {
  className:
    'flex h-[365px] w-[300px] flex-col justify-between overflow-hidden rounded-xl p-2xl'
});

export const CardTitleContainer = createComponent('div', {
  className: 'flex flex-col gap-lg'
});

export const CardTitle = createComponent<
  ElementWithProps<{ inverse?: boolean }>
>('h2', ({ inverse }) => ({
  className: cx(
    't-heading-xl',
    inverse ? 'text-text-inverse' : 'text-text-strong'
  )
}));

export const CardSubtitle = createComponent<
  ElementWithProps<{ inverse?: boolean }>
>('p', ({ inverse }) => ({
  className: cx(
    't-body-sm',
    inverse ? 'text-text-inverse' : 'text-text-default'
  )
}));

export const CardCta = createComponent<ElementWithProps<{ inverse?: boolean }>>(
  'span',
  ({ inverse }) => ({
    className: cx(
      'mx-auto flex w-full items-center justify-center rounded-round px-2xl py-lg t-label-md whitespace-nowrap',
      inverse
        ? 'bg-background-default text-text-primary hover:bg-background-default-hover hover:text-text-primary-hover'
        : 'bg-background-primary text-text-inverse hover:bg-background-primary-hover'
    )
  })
);
